/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popUsdSign.vue?vue&type=template&id=4798e436&scoped=true"
import script from "./popUsdSign.vue?vue&type=script&lang=js"
export * from "./popUsdSign.vue?vue&type=script&lang=js"
import style0 from "./popUsdSign.vue?vue&type=style&index=0&id=4798e436&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4798e436",
  null
  
)

export default component.exports